/* eslint-disable react/jsx-filename-extension */
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
// import './styles/antd.css'
import App from './App'

ReactDOM.render(<App />, document.getElementById('root'))
